// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/index.css
// module id = 332
// module chunks = 140